import React, { useState, useEffect } from "react";

export default function EmojiConveyor({
  emojis = [],
  onTap,
  goldenEmojiId = null,
  treasureEmojiId = null,
  disabled = false,
  playing = false,
  gridCols = 5,
  category = "animals",
  collected = 0,
  total = 9,
  freezeGame,
  freezeUntil,
  setScreen,
  onStart,
}) {
  const [showHint, setShowHint] = useState(true);
  
  const appearedCount = emojis.length;
  const missedCount = Math.max(0, appearedCount - collected);

  // const [visibleCount, setVisibleCount] = useState(0);
  // useEffect(() => {
  //   setVisibleCount(1);
  //   const timer = setInterval(() => {
  //     setVisibleCount((prev) => {
  //       if (prev >= emojis.length) {
  //         clearInterval(timer);
  //         return prev;
  //       }
  //       return prev + 1;
  //     });
  //   }, 450);

  //   return () => clearInterval(timer);
  // }, [emojis]);

  const [visibleCount, setVisibleCount] = useState(0);

useEffect(() => {
  // Do not reveal / animate anything until the player has pressed Start
  if (!playing) {
    setVisibleCount(0);
    return;
  }

  setVisibleCount(1);
    const timer = setInterval(() => {
      setVisibleCount((prev) => {
        if (prev >= emojis.length) {
          clearInterval(timer);
          return prev;
        }
        return prev + 1;
      });
    }, 450);

    return () => clearInterval(timer);
  }, [emojis, playing]);

  return (
    <div className="relative bg-slate-900 border-y border-slate-800">
      <div className="px-2 py-1.5 bg-slate-950 border-b border-slate-700 flex items-center justify-between text-sm">
        <div className="text-cyan-300 font-medium capitalize flex items-center gap-2">
          🧩 {category}
        </div>
        <div className="flex items-center gap-4 text-sm font-semibold">
          <span className="text-emerald-400">✅ {appearedCount}</span>

          <span className="text-red-400">❌ {missedCount}</span>
        </div>
      </div>

      <div className="p-2 pb-4">
        <div
          className="flex gap-3 py-2 px-3 overflow-x-hidden"
          style={{ gridTemplateColumns: `repeat(${gridCols}, minmax(0, 1fr))` }}
        >
          {emojis.length > 0 ? (
            emojis.slice(0, visibleCount).map((emoji, index) => {
              const isGolden = goldenEmojiId === emoji.id;
              const isTreasure = treasureEmojiId === emoji.id;

              return (
                <button
                  key={emoji.id || index}
                  disabled={disabled || !playing}
                  onClick={() => onTap?.(emoji)}
                  className={`relative flex items-center justify-center 
                      w-16 h-16 sm:w-20 sm:h-20 
                      rounded-2xl text-2xl lg:text-4xl 
                      transition-all duration-200 active:scale-90 
                      shadow-lg select-none touch-manipulation
                      ${
                        isGolden
                          ? "bg-yellow-300 ring-4 ring-yellow-400 animate-pulse scale-110"
                          : isTreasure
                            ? "bg-violet-500 ring-4 ring-violet-300 animate-bounce"
                            : "bg-slate-700 hover:bg-slate-600 active:bg-slate-500"
                      }
                    `}
                >
                  <span>{emoji.char || emoji.emoji || emoji.symbol}</span>

                  {isGolden && (
                    <div className="absolute -top-2 -right-2 text-lg lg:text-xl drop-shadow-md">
                      ⭐
                    </div>
                  )}
                  {isTreasure && (
                    <div className="absolute -top-2 -right-2 text-lg lg:text-xl drop-shadow-md">
                      💎
                    </div>
                  )}
                </button>
              );
            })
          ) : (
            <div className="col-span-full py-12 text-center text-slate-400 text-sm">
              Loading new emojis...
            </div>
          )}
        </div>

        <div className="flex justify-center gap-1.5 mt-3">
          {Array.from({ length: Math.min(12, emojis.length || 8) }).map(
            (_, i) => (
              <div key={i} className="w-2 h-2 rounded-full bg-slate-600" />
            ),
          )}
        </div>
      </div>

      {/* Action Bar */}
      <div className="px-3 py-3 border-t border-slate-800 flex gap-2">
        <button
          onClick={() => {
            if (!playing) {
              onStart?.();          
            }
          }}
          disabled={playing}
          className={`w-fit px-4 py-2 rounded-xl font-black text-lg transition
            ${playing
              ? "bg-slate-600 text-slate-300 cursor-not-allowed"
              : "bg-emerald-500 hover:bg-emerald-400 text-white"
            }`}
        >
          {playing ? "▶ Playing…" : "▶ Start Game"}
        </button>

        <button
          onClick={() => freezeGame(5)}
          disabled={!playing}
          className="flex-1 w-fit px-4 py-2 rounded-xl bg-slate-800 border border-slate-700 text-cyan-300 font-bold disabled:opacity-50"
        >
          {freezeUntil > Date.now()
            ? `⏸ ${Math.ceil((freezeUntil - Date.now()) / 1000)}s`
            : "⏸ Freeze"}
        </button>

        <button
          onClick={() => {
            if (setScreen) setScreen("home");
          }}
          className="flex-1 w-fit px-4 py-2 rounded-xl bg-red-500/20 border border-red-500 text-red-300 font-bold"
        >
          🏠 Exit
        </button>
      </div>
    </div>
  );
}